import React from 'react';
import { FiChevronDown } from 'react-icons/fi';

const MobileStepItem = ({ label, summary, isActive, isCompleted, onToggle, icon, children }) => {
  return (
    <div className={`sf-step ${isActive ? 'sf-step--active' : ''} ${isCompleted ? 'sf-step--completed' : ''}`}>
      <button
        type="button"
        className="sf-step__header"
        onClick={onToggle}
      >
        <div className="sf-step__header-left">
          {icon && <span className="sf-step__icon">{icon}</span>}
          <span className="sf-step__label">{label}</span>
        </div>
        <div className="sf-step__header-right">
          {summary && (
            <span className={`sf-step__summary ${isActive ? 'sf-step__summary--active' : ''}`}>
              {summary}
            </span>
          )}
          <FiChevronDown className={`sf-step__chevron ${isActive ? 'sf-step__chevron--open' : ''}`} />
        </div>
      </button>
      <div className={`sf-step__content ${isActive ? 'sf-step__content--open' : ''}`}>
        <div className="sf-step__content-inner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default MobileStepItem;
